<template>
  <Toast 
    position="bottom-center" 
    class="app-toast"
  >
    <template #container="{ message, closeCallback }">
      <section class="toast-container">
        <div class="toast-header">
          <div class="toast-icon">
            <BaseSvgIcon :name="message.severity" />
          </div>
          <div class="toast-content">
            <h4 class="toast-title">{{ message.summary }}</h4>
            <p class="toast-message">{{ message.detail }}</p>
          </div>
          <button class="toast-close" @click.stop="closeCallback">
            <BaseSvgIcon name="close" />
          </button>
        </div>
      </section>
    </template>
  </Toast>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
</script>

<style scoped>
.toast-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 20px;
  max-width: 450px;
  min-width: 320px;
  border: none;
  position: relative;
  overflow: hidden;
}

.toast-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--blue-primary), var(--cyan-primary));
}

.toast-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.toast-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(27, 174, 190, 0.1);
}

.toast-icon .icon {
  font-size: 20px;
  color: var(--blue-primary);
}

.toast-content {
  flex: 1;
  min-width: 0;
}

.toast-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--gray-darker);
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.toast-message {
  font-size: 14px;
  color: var(--gray-dark);
  margin: 0;
  line-height: 1.4;
}

.toast-close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background: transparent;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--gray-medium);
}
</style> 